import { Loader } from 'components'
import { createPortal } from 'react-dom'

import styles from './styles.module.scss'

const ScreenLoader = () =>
  createPortal(
    <div className={styles.loader}>
      <Loader appearance="screen" />
    </div>,
    document.body,
  )

export default ScreenLoader
